import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HumanResourceService } from '../services/human-resource.service';
import { DiaryReportService } from '../services/diary-report.service';
import { MasterDataService } from '../services/master-data.service';

@Component({
  selector: 'app-my-report-list',
  templateUrl: './my-report-list.component.html',
  styleUrls: ['./my-report-list.component.css']
})
export class MyReportListComponent implements OnInit {
  userType;
  userId;
  userDesignation;
  userICAIRegistrationDate;
  articleshipTenureResponse;
  employeeList;
  financialYearList;
  fyId;
  hideTargetForPartnerEmployees = false;
  hideArticleAvailiblityReport = false
  menuList: any;
  allowedComponents = new Set<string>();
  constructor(private router: Router, private humanResourceService: HumanResourceService, private diaryReportService: DiaryReportService, private masterDataService: MasterDataService) { }

  ngOnInit(): void {
    this.userDesignation = localStorage.getItem('userDesignation');
    this.userType = localStorage.getItem('userType');
    this.userICAIRegistrationDate = localStorage.getItem('userICAIRegistrationDate');
    this.articleshipTenureResponse = null;
    this.userId = localStorage.getItem('id');

    // if(this.userType == 'Article')
    //   {
    //     console.log('hide article availiblity report')
    //     this.hideArticleAvailiblityReport=true;
    //   }

    //   if(this.userDesignation == 'Account Executive')
    //     {
    //       console.log('hide article availiblity report')
    //       this.hideArticleAvailiblityReport=true;
    //     }

    //     if(this.userType == 'Consultant')
    //       {
    //         console.log('hide article availiblity report')
    //         this.hideArticleAvailiblityReport=true;
    //       }


    // this.masterDataService.getFinancialYear().subscribe((res) => {
    //   this.financialYearList = res;
    //   console.log('financialList', this.financialYearList)
    //   this.updateFinancialYear();
    // });



    // if(this.userType=='Article')
    // {
    //   this.humanResourceService.getArticleshipTenure(this.userICAIRegistrationDate).subscribe((res: any) => {
    //    console.log('tenure response:',res);
    //    if(res)
    //    {
    //     this.articleshipTenureResponse=res.tenureYears;
    //    }
    //    else{
    //     this.articleshipTenureResponse=null;
    //    }


    //   });
    // }

    this.menuList = JSON.parse(localStorage.getItem('menuList'));
    this.menuList.forEach(menu => {
      menu.menu?.menuComponents?.forEach(component => {
        this.allowedComponents.add(component.name);
      });
    });

  }

  hasAccess(componentName: string): boolean {
    return this.allowedComponents.has(componentName);
  }

  getCurrentFinancialYear(): string {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1; // Month is zero-based
    const currentYear = currentDate.getFullYear();

    const fiscalYearStartMonth = 4; // Assuming fiscal year starts in April

    const financialYear =
      currentMonth < fiscalYearStartMonth
        ? `${currentYear - 1}-${currentYear}`
        : `${currentYear}-${currentYear + 1}`;

    return financialYear;
  }

  getFinancialYearId(): number | null {
    const currentFinancialYear = this.getCurrentFinancialYear();

    const matchingYear = this.financialYearList.find(
      (fy) => fy.name === currentFinancialYear
    );

    return matchingYear ? matchingYear.id : null;
  }

  updateFinancialYear() {
    this.fyId = this.getFinancialYearId();
    console.log('Current Financial Year ID:', this.fyId);
    this.diaryReportService
      .getEmpByBranchRoleMultiPartnerYear(51, '3,5,16,4,2,14,8,9,10,13,11,7,12,6', this.fyId)
      .subscribe((resp: any) => {
        this.employeeList = resp;
        console.log('employee list', resp);
        this.setHideTargetForPartnerEmployees(this.userId);

      });
  }

  setHideTargetForPartnerEmployees(userIdToFind: string): void {
    const userIdAsNumber = parseInt(userIdToFind, 10);

    if (!isNaN(userIdAsNumber)) {
      const employeeFound = this.employeeList.some(employee => employee.id === userIdAsNumber);

      if (employeeFound) {
        this.hideTargetForPartnerEmployees = true;
      }
    } else {
      console.error('Invalid userId:', userIdToFind);
      this.hideTargetForPartnerEmployees = false;
    }
  }

  myLeavesDetailsClick() {
    this.router.navigate(['dashboard/sr-my-leaves']);
  }
  myDiariesClick() {
    this.router.navigate(['dashboard/sr-my-diaries']);
  }
  myStipendClick() {
    this.router.navigate(['dashboard/my-stipend-report']);
  }
  mySalaryClosingClick() {
    this.router.navigate(['dashboard/my-salary-closing']);
  }
  myArticleOneSixthClick() {
    this.router.navigate(['dashboard/my-article-one-sixth-report']);
  }
  myPenaltySummaryClick() {
    this.router.navigate(['dashboard/my-penalty-summary']);
  }
  myAnnualDeclarationClick() {
    this.router.navigate(['dashboard/my-all-independence-declaration']);
  }
  myArticleDeclarationtClick() {
    this.router.navigate(['dashboard/my-all-independence-declaration']);
  }
  // myArticleDebitCreditClick(){
  //   this.router.navigate(['dashboard/article-debit-credit-hours']);
  // }
  myArticleDebitCreditClick() {
    this.router.navigate(
      ['dashboard/article-debit-credit-hours'],
      { state: { isFromMyReportList: true } }
    );
  }
  myActualTaskClick() {
    this.router.navigate(['dashboard/my-actual-task-report']);
  }
  articleAvailabilityClick() {
    this.router.navigate(['dashboard/article-availability-report']);
  }
  myTargetClick() {
    this.router.navigate(['dashboard/my-target-report']);
  }
  myVarianceReportClick() {
    this.router.navigate(['dashboard/my-budget-vs-actual-cost']);
  }
}
